import React, { forwardRef } from 'react';
import { useForm } from 'react-final-form';
import { formatNumber } from '../../../utils/helpers';
import { StyledAreaField, TextAreaContainer } from './styled';
import { TextAreaFieldProps } from './types';

export const TextAreaField = forwardRef<
  HTMLTextAreaElement,
  TextAreaFieldProps
>(
  (
    { stat, name, format, onClick, inputMode = 'text', placeholder, maxLength },
    ref
  ) => {
    const { change } = useForm();

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const textarea = e.target;

      change(name, textarea.value);
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    };

    const parseTextAreaValue = (value: unknown) =>
      inputMode === 'numeric'
        ? formatNumber(value as string | undefined)
        : value;

    const fieldFormat = format as
      | ((value: unknown, name: string) => unknown)
      | undefined;

    return (
      <TextAreaContainer
        tabIndex={0}
        role="button"
        data-stat={stat}
        onClick={onClick}
        onKeyPress={onClick}
        data-cy="text-area-container"
      >
        <StyledAreaField
          ref={ref}
          name={name}
          multiple={true}
          format={fieldFormat}
          autoComplete="off"
          component="textarea"
          maxLength={maxLength}
          data-cy="text-area-input"
          placeholder={placeholder}
          pattern={inputMode === 'numeric' ? '[0-9]*' : null}
          parse={parseTextAreaValue}
          onChange={handleChange}
        />
      </TextAreaContainer>
    );
  }
);

TextAreaField.displayName = 'TextAreaField';
